import { FC, useEffect, useState } from 'react';

import { Alert, Box, Grow, Stack, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';

import { BaseStub } from 'assets/api';
import { Button } from 'components/Elements/Forms/Inputs';
import StandardDialog from 'components/Templates/Pages/StandardDialog';

interface DirectLessonsProps {
  data: BaseStub;
  setData: (a: BaseStub) => void;
  confirmationModalOpen: boolean;
  setConfirmationModalOpen: (a: boolean) => void;
  handleNext: () => void;
}

const DirectLessons: FC<DirectLessonsProps> = props => {
  const [direct, setDirect] = useState<boolean>(true);

  useEffect(() => {
    const tempdata = props.data;
    tempdata.data_bundle.plan_directly = direct;
    props.setData(tempdata);
  }, [direct]);

  return (
    <>
      <Stack p={4} spacing={2}>
        <Box>
          <Stack direction="row" spacing={3} alignItems="center">
            <Checkbox
              checked={direct}
              onChange={(_e, checked) => setDirect(checked)}
            />
            <Typography variant="h4">Ik wil graag zo snel mogelijk bijles (aanbevolen)</Typography>
          </Stack>
          <Grow in={direct}>
            <Alert severity="success">
              Wij gaan direct met je aanvraag aan de slag en koppelen wij je aan een bijlescoach.
              Wij plannen de eerste bijles in op basis van uw beschikbaarheid en je bijlescoach
              neemt contact met u op.
            </Alert>
          </Grow>
          <Stack direction="row" spacing={3} alignItems="center" mt={2}>
            <Checkbox
              checked={!direct}
              onChange={(_e, checked) => setDirect(!checked)}
            />
            <Typography variant="h4">Ik wil graag eerst nog een telefonisch consult</Typography>
          </Stack>
          <Grow in={!direct}>
            <Alert severity="warning" sx={{ display: direct ? 'none' : 'block' }}>
              Wij nemen telefonisch contact met je op. Let op, je aanvraag duurt hierdoor wel
              langer. Hierdoor loop je het risico dat coaches in jouw omgeving volgeboekt zijn,
              zeker rondom toetsenweken en examens.
            </Alert>
          </Grow>
        </Box>
      </Stack>
      <StandardDialog
        showCloseButton
        title="Wil je direct beginnen?"
        open={props.confirmationModalOpen}
        setOpen={props.setConfirmationModalOpen}
        handleClose={() => props.setConfirmationModalOpen(false)}>
        <Typography sx={{ my: 2 }}>
          We gaan zo snel mogelijk aan de slag om met de beste coach voor jou de eerste bijles in te
          plannen. Je krijgt bericht zodra wij een geschikte dag hiervoor gevonden hebben. Je kan
          dit eerste bijlesmoment altijd nog in overleg met de coach aanpassen. Is dit akkoord?
        </Typography>
        <Stack direction="row" justifyContent="space-between">
          <Button
            onClick={() => props.setConfirmationModalOpen(false)}>
            Annuleren
          </Button>
          <Button
            variant="contained"
            onClick={() => props.handleNext()}>
            Ja, ik wil direct beginnen
          </Button>
        </Stack>
      </StandardDialog>
    </>
  );
};

export default DirectLessons;
